
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M30 22.375V30l-7.573-.072-.03-3.052-3.06-.031-.537-2.549-2.555-.534-.03-3.052-3.06-.031-.773-.77a9.17 9.17 0 01-7.676-2.621C1.149 13.74 1.09 8.046 4.576 4.57c3.486-3.476 9.195-3.419 12.751.129a9.118 9.118 0 012.628 7.656L30 22.375zM6.931 10.443c1.138 1.135 2.965 1.154 4.08.041 1.115-1.112 1.097-2.934-.041-4.07-1.138-1.134-2.965-1.153-4.08-.04-1.115 1.112-1.097 2.934.041 4.07z"}})])
          )
        }
      }
    